
import React from "react";

// import MemberPartnerVideoDetails from '../../../../components/MemberPartnerVideoDetails/MemberPartnerVideoDetails';
import MemberPartnerApprovedVideoDetailsPreview from "../../../../components/MemberPartnerVideoDetails/MemberPartnerApprovedVideoDetails";
import { Box } from "@mui/system";

const MyVideoApprovedVideoPage = () => {
  return (
    <Box>
      <MemberPartnerApprovedVideoDetailsPreview />
    </Box>
  );
};

export default MyVideoApprovedVideoPage;
